import { useContext, useEffect, useState } from "react";
import { NavigationContext } from "../../Store/Navigation/context";
import { SettingType } from "../../Store/Navigation/state";
import Sidebar from "../../components/Navigation/Sidebar";
import SidebarButton from "../../components/Navigation/SidebarButton";

interface ISettingsSidebar {
    setSettings: (type: SettingType) => void
    activeSetting: SettingType
}

const SettingsSidebar: React.FC<ISettingsSidebar> = (props) => {

    const state = useContext(NavigationContext).state
    const [developerOptionsActive, setDeveloperOptionsActive] = useState(false)
    
    useEffect(() => {
        setDeveloperOptionsActive(state.developerOptions)
    }, [state.developerOptions])

    return (
        <Sidebar>
            <SidebarButton
                tab={SettingType.CAPTURING}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.CAPTURING}
            >
                Capturing
            </SidebarButton>
            <SidebarButton
                tab={SettingType.DETECTION}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.DETECTION}
            >
                Detection
            </SidebarButton>
            <SidebarButton
                tab={SettingType.TRACKING}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.TRACKING}
            >
                Tracking
            </SidebarButton>
            <SidebarButton
                tab={SettingType.FACE_QUALITY}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.FACE_QUALITY}
            >
                Face quality
            </SidebarButton>
            <SidebarButton
                tab={SettingType.VERIFICATION}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.VERIFICATION}
            >
                Verification
            </SidebarButton>
            <SidebarButton
                tab={SettingType.LIVENESS}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.LIVENESS}
            >
                Liveness
            </SidebarButton>
            <SidebarButton
                tab={SettingType.ATTRIBUTES}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.ATTRIBUTES}
            >
                Attributes
            </SidebarButton>
            <SidebarButton
                tab={SettingType.ICAO}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.ICAO}
            >
                ICAO
            </SidebarButton>
            <SidebarButton
                tab={SettingType.MANAGEMENT}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.MANAGEMENT}
            >
                Management
            </SidebarButton>
            <SidebarButton
                tab={SettingType.ACCOUNTS}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.ACCOUNTS}
            >
                Accounts
            </SidebarButton>
            <SidebarButton
                tab={SettingType.ADJUDICATION}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.ADJUDICATION}
            >
                Adjudication
            </SidebarButton>
            {developerOptionsActive ?
                <SidebarButton
                    tab={SettingType.DEVELOPER}
                    setTab={props.setSettings}
                    activeTab={props.activeSetting === SettingType.DEVELOPER}
                >
                    Developer
                </SidebarButton> : null
            }
            <SidebarButton
                tab={SettingType.RESET}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.RESET}
            >
                Reset
            </SidebarButton>
            <SidebarButton
                tab={SettingType.ABOUT}
                setTab={props.setSettings}
                activeTab={props.activeSetting === SettingType.ABOUT}
            >
                About
            </SidebarButton>
        </Sidebar>
    );
}

export default SettingsSidebar